import { Nilable } from "@shared/utils";

export interface IPayloadEtiquetasDTO {
   prize: number;
   legacy: Nilable<string>;
}

export class PayloadEtiquetasDTO {
    public precio = 0;
    public legacy = "";

    constructor(json: Nilable<Partial<IPayloadEtiquetasDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPayloadEtiquetasDTO>) {
        if (json.prize != null) {
            this.precio = json.prize;
        }
        if (json.legacy != null) {
            this.legacy = json.legacy;
        }
    }

    public toJSON(): IPayloadEtiquetasDTO {
        return {
            prize: this.precio,
            legacy: this.legacy
        };
    }
}
